import { FETCH_USERS_PAGINATED } from '@/store/actionTypes'

export const CHANGE_DEFAULT_SPACE = 'organization/space/default/CHANGE'
export const CHANGE_DEFAULT_SPACE_SUCCESS = `${CHANGE_DEFAULT_SPACE}_SUCCESS`

export const UPDATE_ORGANIZATION = 'organization/UPDATE'
export const UPDATE_ORGANIZATION_SUCCESS = `${UPDATE_ORGANIZATION}_SUCCESS`

export const ADD_ORGANIZATION_ADMIN = 'organization/admins/ADD'
export const ADD_ORGANIZATION_ADMIN_SUCCESS = `${ADD_ORGANIZATION_ADMIN}_SUCCESS`

export const REMOVE_ORGANIZATION_ADMIN = 'organization/admins/REMOVE'
export const REMOVE_ORGANIZATION_ADMIN_SUCCESS = `${REMOVE_ORGANIZATION_ADMIN}_SUCCESS`

// Note keep these action names unique - see UsersReducer.js
export const FETCH_ORGANIZATION_ADMINS = 'organization/admins/GET'
export const FETCH_ORGANIZATION_ADMINS_SUCCESS = `${FETCH_ORGANIZATION_ADMINS}_SUCCESS`

export const FETCH_ORG_USERS_TO_ADD = `${FETCH_USERS_PAGINATED}_ORG_USERS_TO_ADD`
export const FETCH_ORG_USERS_TO_ADD_SUCCESS = `${FETCH_ORG_USERS_TO_ADD}_SUCCESS`
